import {
  DatePickerController,
  GroupCodesController,
  ImagesUploadController,
  NominalIdsController,
} from '@/components/controls';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import { startOfDay } from 'date-fns';
import { Fragment, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { CategoriesController } from './CategoriesController';

export function IntelligenceItemEditorDialog({
  item,
  isOpen,
  onClose,
  onDelete,
}) {
  const { control, handleSubmit, reset } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: item,
  });

  useEffect(() => {
    reset(item);
  }, [reset, item, isOpen]);

  function handleClose() {
    onClose();
  }

  return (
    <form id="notice-editor-form" onSubmit={handleSubmit(onClose)}>
      <Dialog open={isOpen && !!item} onClose={handleClose}>
        <DialogTitle>{`${item.code ? 'Edit' : 'Add'} Item`}</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <DialogContentText gutterBottom>
              Please fill in the form below to add a notice. If groups are not
              specified then the intelligence will be visible to all.
            </DialogContentText>
            <GroupCodesController
              label="Groups"
              control={control}
              name="groupCodes"
              types={['SECTOR', 'TEAM']}
            />
            <Controller
              name="title"
              control={control}
              rules={{ required: 'Required' }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Title"
                  error={!!error}
                  helperText={error?.message}
                  size="small"
                />
              )}
            />
            <DatePickerController
              name="expiryDate"
              label="Expiry Date"
              control={control}
              rules={{ required: 'Required' }}
              minDate={startOfDay(new Date())}
            />
            <Controller
              name="intelligenceId"
              control={control}
              rules={{
                // validate: (value) => !value || isIntelligenceId(value),
                required: 'Required',
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Intelligence ID"
                  placeholder="XXXXXXXXX"
                  error={!!error}
                  helperText={error?.message}
                  size="small"
                />
              )}
            />
            <Controller
              name="message"
              control={control}
              rules={{ required: 'Required' }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Message"
                  multiline
                  rows={8}
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
            <CategoriesController
              name="categories"
              label="Categories"
              control={control}
            />
            <NominalIdsController
              control={control}
              name="nominalIds"
              label="Nominal IDs"
            />
            <ImagesUploadController name="imageSrcs" control={control} />
          </Stack>
        </DialogContent>
        <DialogActions>
          {!!item.code && (
            <Fragment>
              <Button color="error" onClick={onDelete}>
                Delete
              </Button>
              <Box sx={{ flexGrow: 1 }} />
            </Fragment>
          )}
          <Button onClick={handleClose}>Cancel</Button>
          <Button form="notice-editor-form" type="submit">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}
